<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>基础管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索筛选 -->
    <el-form :inline="true" style="margin-top: 20px;">
      <el-form-item label="视频是否开启审核:">
        <el-switch
          v-model="value2"
          active-color="#13ce66"
          @change="switchChange"
          inactive-color="#ff4949"
        >
        </el-switch>
        {{ value2 ? "需要手动审核" : "自动审核通过" }}
      </el-form-item>

      <div>
        <el-form-item label="提现功能配置:">
          <div class="align-center">
            <el-form-item label="提现日期(直接填写数字)">
              <el-input
                v-model="times"
                style="width:200px"
                placeholder="请输入值"
              ></el-input>
            </el-form-item>
            <el-form-item label="提现税率(%)">
              <el-input
                v-model="tax"
                style="width:200px"
                placeholder="请输入值"
              ></el-input>
            </el-form-item>
            <el-button type="primary" @click="saveTaxClick">保存</el-button>
          </div>
        </el-form-item>
      </div>

      <el-form-item label="发布课程钻石配置:">
        <div class="align-center">
          <el-form-item label="创建课程所需钻石(直接填写数字)">
            <el-input
              v-model="taskPrice"
              style="width:200px"
              placeholder="请输入值"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="个人收益百分比(例如:填写10就是10%客户端展示是9:1)"
          >
            <el-input
              v-model="taskGr"
              style="width:200px"
              placeholder="请输入值"
            ></el-input>
          </el-form-item>
          <el-button type="primary" @click="saveTaskClick">保存</el-button>
        </div>
      </el-form-item>
      <el-form-item label="更新app版本:">
        <div class="align-center">
          <el-form-item
            label="请输入app更新版本号"
          >
            <el-input
              v-model="versionNumber"
              style="width:200px"
              type="number"
              placeholder="请输入值"
            ></el-input>
          </el-form-item>
          <el-button type="primary" @click="upVersionFn">保存</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  getAduitStatus,
  setAduitStatus,
  getTaxInfo,
  upTax,
  upAdminTaskPrice,
  getTaskPrice,
  upVersion,
  getVersion
} from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      value2: true,
      keyword: "",
      content: "",

      // 用户数据
      revData: [],

      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      },
      times: "", //提现日期
      tax: "", //税率
      taxId: "",
      taskId: "",
      taskGr: "",
      taskPrice: "",
      taskPt: "",
      versionNumber: 0 //版本号
    };
  },
  // 注册组件
  components: {
    Pagination
  },
  created() {
    this.getdata(1);
    this.getTaxInfoFn();
    this.getTaskPriceFn();
    this.getVersionFn(); //查询当前版本
  },
  methods: {
    getVersionFn() {
      getVersion().then(res => {
        if (res.code == 200) {
          this.versionNumber = res.data.data.version;
        }
      });
    },
    upVersionFn() {
      if(this.versionNumber==null){
          this.$error("不能为空");
          return 
      }
      upVersion({
        token: localStorage.getItem("logintoken"),
        version: this.versionNumber
      }).then(res => {
        if (res.code == 200) {
          this.$message("修改成功");
          this.getVersionFn()
        }
      });
    },
    getTaskPriceFn() {
      getTaskPrice().then(res => {
        if (res.code == 200) {
          console.log("res=getTaskPrice==", res);
          this.taskPrice = res.data.data.price; //钻石数量
          this.taskGr = res.data.data.gr; //个人比例
          this.taskId = res.data.data.id;
          this.taskPt = res.data.data.pt;
        }
      });
    },
    getTaxInfoFn() {
      getTaxInfo().then(res => {
        console.log("res=getTaxInfo==", res);
        if (res.code == 200) {
          this.times = res.data.data.times;
          this.tax = res.data.data.tax;
          this.taxId = res.data.data.id;
        }
      });
    },
    saveTaskClick() {
      let data = {
        id: this.taskId,
        price: this.taskPrice,
        gr: this.taskGr,
        pt: this.taskPt
      };
      upAdminTaskPrice(data).then(res => {
        console.log("res===upTax=====", res);
        this.$message(res.msg);
        if (res.code == 200) {
          this.getTaskPriceFn();
        }
      });
    },
    saveTaxClick() {
      let data = {
        id: this.taxId,
        tax: this.tax,
        times: this.times
      };
      upTax(data).then(res => {
        console.log("res===upTax=====", res);
        this.$message(res.msg);
        if (res.code == 200) {
          this.getTaxInfoFn();
        }
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.pageparm.page = parm.currentPage;
      this.getdata(parm.currentPage);
    },
    //搜索数据
    search() {
      this.getdata();
    },
    // 重置数据
    chongzhi() {
      this.keyword = "";
      this.content = "";
      this.getdata();
    },

    // 获取数据
    getdata() {
      getAduitStatus().then(res => {
        console.log("resw==============", res);
        if (res.code == 200) {
          if (res.data.data == 1) {
            this.value2 = true;
          } else {
            this.value2 = false;
          }
        }
      });
    },
    switchChange(e) {
      console.log("e========", e);
      let status = this.value2 == true ? "1" : "0";
      setAduitStatus({
        status
      }).then(res => {
        if (res.code == 200) {
          this.getAduitStatus();
        }
      });
    }
  }
};
</script>

<style>
.align-center {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/terrace/toExamine.vue